import { TenorFieldUnitOption } from 'components/shared/TenorField/TenorField';

export function getTenorFieldUnitLabel(availableUnits: TenorFieldUnitOption[], unitValue: string): string {
  const matchedUnit = availableUnits.find(unit => unit.value === unitValue);
  return matchedUnit ? matchedUnit.label : unitValue;
}
